import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import { useThread } from '@ts-core/hooks/forum';

import ThreadForm from '@ts-core/components/Forum/ThreadForm';

const EditThreadPage = () => {
  const history = useHistory();
  const { courseId, threadId } = useParams();

  const onThreadUpdated = useCallback(() => {
    history.push(`/${courseId}/forum/${threadId}`);
  }, [history, courseId, threadId]);

  const { thread, updatingThread, onUpdateThread } = useThread({
    courseId,
    threadId,
    onThreadUpdated,
  });

  const handleGoBack = useCallback(() => {
    history.push(`/${courseId}/forum/${threadId}`);
  }, [history, courseId, threadId]);

  return (
    <>
      <BackButton
        title={
          <FormattedMessage id="forum.editPost" defaultMessage="Editar Post" />
        }
        subtitle={<FormattedMessage id="forum.title" defaultMessage="Foro" />}
        onGoBack={handleGoBack}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={{ md: '100%', lg: 800 }}
        margin="auto"
      >
        {thread?._id && (
          <ThreadForm
            onSubmit={onUpdateThread}
            submitting={updatingThread}
            thread={thread}
          />
        )}
      </Box>
    </>
  );
};

export default EditThreadPage;
